export function isAssociatedServiceVisibile(
  userData: any,
  quotationPermissions: string[]
) {
  if (!userData) {
    return false;
  }
  if (quotationPermissions.includes("public")) {
    return true;
  }
  return quotationPermissions.includes(userData.role_type);
}
